import type { BillingView, Plan, PlanSummary } from "./api";

type Subscription = NonNullable<BillingView["subscription"]>;

/**
 * What an upgrade costs now, the way the server charges it: the price
 * difference and the extra episodes, for the part of the month that is left.
 */
export function upgradeEstimate(
  subscription: Pick<Subscription, "currentPeriodStart" | "currentPeriodEnd" | "plan">,
  target: Pick<PlanSummary | Plan, "priceAgorot" | "episodesPerPeriod">,
  now = Date.now(),
): { agorot: number; episodes: number } {
  const start = new Date(subscription.currentPeriodStart).getTime();
  const end = new Date(subscription.currentPeriodEnd).getTime();
  const left = Math.min(1, Math.max(0, (end - now) / (end - start)));
  return {
    agorot: Math.round((target.priceAgorot - subscription.plan.priceAgorot) * left),
    episodes: Math.max(0, Math.round((target.episodesPerPeriod - subscription.plan.episodesPerPeriod) * left)),
  };
}
